import { render, staticRenderFns } from "./VehicleDelivery.vue?vue&type=template&id=71654c11&scoped=true&lang=pug"
import script from "./VehicleDelivery.vue?vue&type=script&lang=js"
export * from "./VehicleDelivery.vue?vue&type=script&lang=js"
import style0 from "./VehicleDelivery.vue?vue&type=style&index=0&id=71654c11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71654c11",
  null
  
)

export default component.exports